import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import * as actions from "../Actions";
import { Beforeunload } from "react-beforeunload";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Height from "../Height";

// import write from "../Reducers";

const Container = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 30px;
  justify-content: center;
`;

const Box = styled.div`
  width: 90%;
  display: flex;
  justify-content: center;
`;

const Form = styled.form`
  padding-bottom: 5px;
  display: flex;
  justify-content: center;
`;

const Button = styled.button`
  background-color: transparent;
  border-radius: 20px;
  padding: 5px 10px;
  width: auto;
  min-height: 40px;
  max-height: 100px;

  font-size: 24px;
  opacity: 0.3;
  color: rgba(24, 12, 12, 1);
  font-weight: 800;
`;

const WriteBox = styled.div`
  height: 100vh;
  z-index: 1001;
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  opacity: 1;
  background-color: #0063eb;
  display: ${props => (props.write ? "flex" : "none")};
  flex-direction: column;
`;

const WriteHeader = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  padding: 17px 15px 13px;
`;

const WriteConfirm = styled.div`
  /* background-color: rgba(24, 12, 12, 1); */
  color: rgba(24, 12, 12, 1);
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  opacity: 0.3;
  font-weight: 800;
  &:hover {
    opacity: 1;
  }
`;

const WriteArea = styled.textarea`
  width: 100%;
  padding: 15px;
  height: 250px;
  background-color: transparent;
  font-weight: 800;
  font-size: 48px;
  color: rgba(24, 12, 12, 1);
  &::placeholder {
    color: rgba(24, 12, 12, 1);
    opacity: 0.3;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    font-size: 24px;
  }
`;

class Contents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      write: false,
      sum: ""
    };
    this.inputFormHandler = this.inputFormHandler.bind(this);
    this.sumContent = this.sumContent.bind(this);
    this.writeHandler = this.writeHandler.bind(this);
    this.textInput = React.createRef();
  }

  writeHandler(e) {
    e.preventDefault();
    if (this.state.write) {
      if (this.props.stage === "sum") {
        this.props.upload("sum", this.state.sum);
        document.getElementById("sum").innerHTML =
          this.state.sum === ""
            ? "완벽한 글은 없습니다!"
            : this.length(this.state.sum);
      } else {
        const content = this.props.text[this.props.stage];
        document.getElementById(this.props.stage).innerHTML =
          content === "" ? this.props.placeholder : this.length(content);
      }
      this.setState({
        write: false
      });
    } else {
      this.setState(
        {
          write: true
        },
        () => {
          this.textInput.current.focus();
        }
      );
    }
  }

  componentDidMount() {
    if (this.props.stage === "sum") {
      const sum = this.sumContent();
      this.props.upload("sum", sum);
      this.setState(
        {
          sum: sum
        },
        () => {
          document.getElementById("sum").innerHTML =
            sum === "" ? "완벽한 글은 없습니다!" : this.length(this.state.sum);
          document.getElementsByName("sum")[0].value = sum;
        }
      );
    } else {
      const content = this.props.text[this.props.stage];
      document.getElementById(this.props.stage).innerHTML =
        content === "" ? this.props.placeholder : this.length(content);
      document.getElementsByName(this.props.stage)[0].value = content;
    }
  }

  length(value) {
    if (value.length > 40) {
      value = value.substring(0, 40) + "...";
      return value;
    }
    return value;
  }

  inputFormHandler(e) {
    const title = this.props.stage;
    const content = document.getElementsByName(this.props.stage)[0].value;
    title === "sum"
      ? this.setState({ sum: content })
      : this.props.upload(title, content);
  }

  sumContent() {
    const { opinion, reason, example, offer } = this.props.text;
    if (opinion === "" && reason === "" && example === "" && offer === "") {
      return "";
    }
    const sum = opinion + " " + reason + " " + example + " " + offer;
    return sum;
  }

  render() {
    const { stage, placeholder } = this.props;
    return (
      <Beforeunload onBeforeunload={() => "You'll lose your data!"}>
        <Container>
          <Box>
            <Form>
              <Button id={stage} onClick={this.writeHandler}>
                {placeholder}
              </Button>
            </Form>
          </Box>
          <WriteBox write={this.state.write}>
            <WriteHeader>
              <WriteConfirm className="disableDrag" onClick={this.writeHandler}>
                확인
                {/* <FontAwesomeIcon icon={faArrowLeft} /> */}
              </WriteConfirm>
            </WriteHeader>
            <WriteArea
              ref={this.textInput}
              spellCheck="false"
              onInput={this.inputFormHandler}
              name={stage}
              placeholder={placeholder}
            ></WriteArea>
          </WriteBox>
        </Container>
      </Beforeunload>
    );
  }
}

const mapStateToProps = state => {
  return {
    text: state.Reducer.text
  };
};

const mapDispatchToProps = dispatch => {
  return {
    upload: (title, content) => {
      dispatch(actions.write(title, content));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contents);
